var Icon = require("app/shared/components/Icon/icon");
var cx = require("classnames");

var DealStatus = ({ label, icon, selected, selectedClass }) => {
  var baseClass = "deal-status";
  var classes = cx(baseClass, { [`${baseClass}-${selectedClass}`]: selected });
  var icon = `${baseClass}-${icon}`;

  return (
    <div className={classes}>
      <Icon custom icon={icon} className="va-middle mr-5" />
      <span className="va-middle">{label}</span>
    </div>
  );
};

module.exports = DealStatus;


// WEBPACK FOOTER //
// ./app/shared/components/Hover/deal-status.jsx